export default "__VITE_ASSET__C6ghRuG3__"